import './Title.css'

export default function Title(){
    return (
        <header id="home">
            <div className="header-text text-start display-2">
            <p>Hi,</p>
            <p>I'm Robyn,</p>
            <p>Software Engineer.</p>
            </div>
        </header>
    );
}